import React from 'react';
import RestInputItem from 'components/RestInput/RestInputItem';

const CustomersForm = (props) => (
  <div {...props}>
    <RestInputItem source="content" header="customers.content" />
  </div>
);

export default CustomersForm;
